import React, { useContext, useEffect, useState } from 'react';
import Navigation from '@components/NavigationV2';
import {
  GlobalDispatchContext,
  GlobalStateContext,
} from '@src/context/GlobalContextProvider';

import AiSkillDevelopmentPageHero from './PageHero';

export default function SkillAssessmentPage(props) {
  const globalState = useContext(GlobalStateContext);
  const globalDispatch = useContext(GlobalDispatchContext);

  const [savedInterviewData, setSavedInterviewData] = useState(null);

  const [hasMounted, setHasMounted] = useState(false);

  useEffect(() => {
    setHasMounted(true);
    const interviewData = globalState?.interviewData;

    if (interviewData?.activation_time) {
      const activationTime = new Date(interviewData.activation_time);
      const expirationTime = new Date(
        activationTime.getTime() + 2 * 60 * 60 * 1000,
      ); // +2 hours
      const currentTime = new Date();

      if (currentTime > expirationTime) {
        globalDispatch({
          type: 'SET_INTERVIEW_RESPONSE',
          payload: null,
        });
        setSavedInterviewData(null);
      } else {
        setSavedInterviewData(interviewData);
      }
    } else {
      setSavedInterviewData(interviewData);
    }
  }, [globalState?.interviewData]);

  if (!hasMounted) return null; // ✅ Prevent flicker and mismatch

  return (
    <div>
      <div className="mx-auto w-full md:max-w-[1200px]">
        <div className="relative mx-4 h-fit max-w-[1300px] md:mx-auto md:px-4">
          <div className="fixed left-0 top-0 z-[1001] w-screen">
            <Navigation hideCTA />
          </div>

          <div className="mx-4 mt-[80px] flex h-full flex-col items-center gap-10 md:h-[600px] md:flex-row">
            <AiSkillDevelopmentPageHero buttonText={props.buttonText} />
          </div>
        </div>
      </div>
    </div>
  );
}
